export default __webpack_public_path__ + "static/media/Quickness of the Katari.f7d435af.jpg";